/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = '___locache___/campaign_reports';

const getLocalStorageObj = ({ key }) => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

const getLocalStorage = (fieldName, defaultValue) => {
  try {
    const item = window.localStorage.getItem(STORAGE_KEY);
    return JSON.parse(item)?.[fieldName] ?? defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

const saveLocalStorageItem = ({ key, field, value }) => {
  const objFromLS = getLocalStorageObj({ key });
  try {
    const updatedValue = { ...objFromLS, [field]: value };
    window.localStorage.setItem(key, JSON.stringify(updatedValue));
  } catch (error) {
    console.error(error);
  }
};

const deleteLocalStorageItem = (key, prop) => {
  const data = JSON.parse(localStorage.getItem(key) || '{}');
  delete data[prop];
  localStorage.setItem(key, JSON.stringify(data));
};

const getDefaultState = () => {
  return {
    tableRequestTypes: getLocalStorage('tableRequestTypes', 'Apps'),
    isChartHiddenCampaignReports: getLocalStorage('isChartHiddenCampaignReports', true),
    isChartDisabledCampaignReports: false,
    selectedSearchApps: getLocalStorage('selectedSearchApps', []),
    selectedCountries: getLocalStorage('selectedCountries', []),
    appFilter: getLocalStorage('appFilter', 'all_status'),
    tableAppsList: null,
    isPressedBulkBtn: false,
    selectedMetricsCampaignReports: getLocalStorage('selectedMetricsCampaignReports', {
      installs: true,
      impressions: true,
      clicks: true,
      cost: true,
      cr: true,
      avg_cpi: true,
      events: true,
      avg_cpa: true,
    }),
    selectedEvents: getLocalStorage('selectedEvents', []),
    selectedCols: getLocalStorage('selectedCols', []),
    selectedColLabels: getLocalStorage('selectedColLabels', []),
    currentEventInd: 0,
    selectedTableItems: [],
    campaignName: '',
    updatedBidsArray: [],
  };
};

const campaignReportsSlice = createSlice({
  name: 'campaignReports',
  initialState: getDefaultState(),
  reducers: {
    clearFilters: (state, action) => {
      state.selectedSearchApps = [];
      state.selectedCountries = [];
      state.appFilter = 'all_status';
    },
    clearState: (state, action) => {
      state.selectedTableItems = [];
      state.isPressedBulkBtn = false;
      state.selectedEvents = [];
      state.tableAppsList = null;
      deleteLocalStorageItem('___locache___/campaign_reports', 'selectedEvents');
    },
    updateProperty: (state, action) => {
      saveLocalStorageItem({
        key: STORAGE_KEY,
        field: action.payload.propField,
        value: action.payload.newValue,
      });
      state[action.payload.propField] = action.payload.newValue;
    },
    addUpdatedBids: (state, action) => {
      const currentState = [...state.updatedBidsArray];
      const newItems = action.payload;
      const newState = [
        ...currentState.filter((item) => !newItems.some((el) => el.id === item.id)),
        ...newItems,
      ];
      state.updatedBidsArray = newState;
    },
    clearUpdatedBids: (state) => {
      state.updatedBidsArray = [];
    },
  },
});

export const campaignReportsActions = campaignReportsSlice.actions;
campaignReportsActions.CAMPAIGN_REPORTS_STORAGE_KEY = STORAGE_KEY;
export default campaignReportsSlice.reducer;
